import { computed, inject, unref } from 'vue'
import { useRoute } from 'vue-router'
import {
  getMobileBaseFromRoute,
  MOBILE_DESKTOP_EMBED_BASE,
  MOBILE_STANDALONE_BASE,
  joinMobilePath
} from '@/utils/mobileWorkbenchBase'

export const MOBILE_BASE_KEY = Symbol('mobileWorkbenchBase')

/**
 * 移动工作台内路由：随 /m 或 /desktop-mobile 前缀切换，供页面 router-link / push 使用。
 */
export function useMobileWorkbench() {
  const route = useRoute()
  const injected = inject(MOBILE_BASE_KEY, null)
  const basePath = computed(() => {
    const v = injected ? unref(injected) : null
    return v || getMobileBaseFromRoute(route)
  })
  const isEmbeddedInDesktop = computed(() => basePath.value === MOBILE_DESKTOP_EMBED_BASE)

  function mPath(suffix) {
    return joinMobilePath(basePath.value, suffix)
  }

  /** 桌面内嵌路由 name 带 Dm 前缀，与 router/mobileWorkbenchChildren 一致 */
  function mRouteName(vueRouteName) {
    const prefix = isEmbeddedInDesktop.value ? 'Dm' : ''
    return `${prefix}${vueRouteName}`
  }

  return {
    basePath,
    isEmbeddedInDesktop,
    mPath,
    mRouteName,
    MOBILE_STANDALONE_BASE,
    MOBILE_DESKTOP_EMBED_BASE
  }
}
